import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    isTesting: false,
    whatsappConfigData: [],
    isConfigLoading: false
};
const WhatsappConfigReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.WHATSAPP_CONFIG_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                isConfigLoading: true,
                whatsappConfigData: [],
            };
        case ActionTypes.WHATSAPP_CONFIG_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isConfigLoading: false,
                whatsappConfigData: action.payload?.data?.data || [],
            };
        case ActionTypes.WHATSAPP_CONFIG_GET_ERROR:
        case ActionTypes.WHATSAPP_CONFIG_UPSERT_ERROR:
            return {
                ...state,
                isLoading: false,
                isConfigLoading: false,
            };

        case ActionTypes.WHATSAPP_CONFIG_UPSERT_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.WHATSAPP_CONFIG_UPSERT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                whatsappConfigData: action.payload?.data?.data || [],
            };

        case ActionTypes.WHATSAPP_CONFIG_TEST_REQUEST:
            return {
                ...state,
                isTesting: true,
            };
        case ActionTypes.WHATSAPP_CONFIG_TEST_SUCCESS:
        case ActionTypes.WHATSAPP_CONFIG_TEST_ERROR:
            return {
                ...state,
                isTesting: false,
            };

        default:
            return state;
    }
};

export default WhatsappConfigReducer;
